import styled from "styled-components";

import Button from "core/Button";

import { textMd } from "core/fontStyles";
import { spacingWithBreakpoints } from "core/spacing";
import { convertPxToRem } from "frontend/components/helpers";

export const GetIconButton = styled(Button).attrs({
    styleType: "cta",
    darkMode: true,
    width: "100%"
})`
    &[aria-disabled="true"]:focus {
        outline: none;
        box-shadow: none;
    }
`;

// KeepEditsWarning component styles:

export const KeepEditsText = styled.p`
    ${textMd}
    ${spacingWithBreakpoints.LGBottom}
`;

export const KeepEditsButton = styled(Button).attrs({
    size: "lg",
    styleType: "solid"
})`
    margin-right: ${convertPxToRem({ px: 24 })};
`;

export const LoseEditsButton = styled(Button).attrs({
    styleType: "outline"
})``;
